import api from "lib/api";
import apiFormData from "lib/apiFormData";

export const getWhiteList = async (params = {}) => {
    return await api.post("/v1/webapp/getWhiteList", params);
};

export const getRequestLoanList = async (params = {}) => {
    return await api.post("/v1/webapp/getRequestLoanList", params);
};
export const getRequestLoanListByCompany = async (params = {}) => {
    return await api.post("/v1/webapp/getRequestLoanListByCompany", params);
};

export const getLoanTransferStatus = async (params = {}) => {
    return await api.post("/v1/webapp/loanTransferStatus", params);
};

export const getUpdateTxnRequest = async (params = {}) => {
    return await api.post("/v1/webapp/updateTxnRequest", params);
};

export const importWhitelist = async (params = {}) => {
    return await apiFormData.post("/v1/webapp/importWhitelist", params);
};
export const exportExcelWhitelist = async (params = {}) => {
    return await api.post("/v1/webapp/exportExcelWhitelist", params, {
        responseType: 'blob'
    });
};
export const exportFileHistory = async (params = {}) => {
    return await api.post("/v1/webapp/exportFileHistory", params, {
        responseType: 'blob'
    });
};

export const getDropdownProduct = async (params = {}) => {
    return await api.post("/v1/dropdown/getProduct", params);
};
export const getFileHistory = async (params = {}) => {
    return await api.post("/v1/webapp/getFileHistory", params);
};

export const exportWelfareLoanFile = async (params = {}) => {
    return await api.post("/v1/webapp/exportExcelRequestLoanListByCompany", params, { responseType: 'blob' });
};
export const getCommonTypeByGroupType = async (params = {}) => {
    return await api.post("/v1/dropdown/getCommonTypeByGroupType", params);
};